/**
 * SettingsSkeleton Component
 *
 * Loading skeleton for the settings page.
 * Follows Shopify Polaris skeleton patterns.
 */

import {
  SkeletonPage,
  Layout,
  Card,
  BlockStack,
  Box,
  SkeletonBodyText,
  SkeletonDisplayText,
} from '@shopify/polaris';

export function SettingsSkeleton() {
  return (
    <SkeletonPage
      title="Settings"
      backAction
      primaryAction
    >
      <Layout>
        {/* Primary Column - Preferences */}
        <Layout.Section>
          {/* Email Recipients Card */}
          <Card>
            <BlockStack gap="400">
              <SkeletonDisplayText size="small" />
              <Box paddingBlockStart="200">
                <BlockStack gap="400">
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={1} />
                </BlockStack>
              </Box>
            </BlockStack>
          </Card>

          {/* Email Settings Card */}
          <Card>
            <BlockStack gap="400">
              <SkeletonDisplayText size="small" />
              <Box paddingBlockStart="200">
                <BlockStack gap="400">
                  <SkeletonBodyText lines={2} />
                  <SkeletonBodyText lines={2} />
                </BlockStack>
              </Box>
            </BlockStack>
          </Card>

          {/* Notification Channels Card */}
          <Card>
            <BlockStack gap="400">
              <SkeletonDisplayText size="small" />
              <Box paddingBlockStart="200">
                <SkeletonBodyText lines={4} />
              </Box>
            </BlockStack>
          </Card>
        </Layout.Section>

        {/* Secondary Column - Metadata */}
        <Layout.Section variant="oneThird">
          <Card>
            <BlockStack gap="400">
              <SkeletonDisplayText size="small" />
              <Box paddingBlockStart="200">
                <SkeletonBodyText lines={3} />
              </Box>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
}
